export default "__VITE_ASSET__3UPfN674__"